import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { Ope } from 'src/app/models/Ope';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { DocServices } from 'src/app/services/docs/docs.services';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-galerie',
  templateUrl: './galerie.component.html',
  imports: [CommonModule,ToastModule,ProgressBarModule,TableModule,NgxSplideModule],
  styleUrls: ['./galerie.component.scss']
})
export class GalerieComponent implements OnInit {
  pathListImages: vignetteOpe[] = [];
  programmeseled!: Ope;
  mavignette!: vignetteOpe;

  onSplideInit(event: any) {

  }
  constructor(public share: shareOpeSevices, private readonly docs: DocServices) { }

  ngOnInit() {
    // this.share.VignettesOffOpe$.subscribe(res=>{
    //   this.pathListImages=res;
    // })
    this.share.datasOpe$.subscribe(data => this.programmeseled = data);
    this.share.VignettesOffOpe$.subscribe(data =>
      this.pathListImages = data
    )


  }

}
